/*
 * IndusindMinKyc actions
 */

import * as reqHandler from '../../config/services/serviceHandler';
import endpoint from '../../config/endPoints';
import {
  rootApiResponse,
  clearDefaultError,
} from '../HeaderContainer/actions';
import {
  errorResponse, successResponse,
} from '../../devUtils/commonUtils';
import { utils } from '../../devUtils';
import {
  DEFAULT_ACTION,
  SET_INDUSIND_MIN_KYC_CITIES_SUCCESS,
  SET_INDUSIND_MIN_KYC_USER_INFO_SUCCESS,
  SET_INDUSIND_MIN_KYC_USER_UPDATE_SUCCESS,
  SET_INDUSIND_MIN_KYC_USER_DETAILS_SUCCESS,
  SET_DEDUPE_VERIFY_SUCCESS,
} from './constants';
import { PAY_BALANCE_CONSTANT } from '../PayBalance/constants';

const indusindMinKycCitiesSuccess = (payload) => ({ type: SET_INDUSIND_MIN_KYC_CITIES_SUCCESS, payload });
const indusindMinKycUserInfoSuccess = (payload) => ({ type: SET_INDUSIND_MIN_KYC_USER_INFO_SUCCESS, payload });
const indusindMinKycUserUpdateSuccess = (payload) => ({ type: SET_INDUSIND_MIN_KYC_USER_UPDATE_SUCCESS, payload });
const indusindMinKycUserDetailsSuccess = (payload) => ({ type: SET_INDUSIND_MIN_KYC_USER_DETAILS_SUCCESS, payload });
const dedupeVerifySuccess = (payload) => ({ type: SET_DEDUPE_VERIFY_SUCCESS, payload });

const indusindMinKycCities = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.getHandler(api, endpoint.GET_INDUSIND_MIN_KYC_CITIES, payload, authPrerequist);
    return dispatch(indusindMinKycCitiesSuccess(response));
  } catch (err) {
    dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
    return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
  }
};

const indusindMinKycUserInfo = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.getHandler(api, endpoint.GET_INDUSIND_MIN_KYC_USER_INFO, payload, authPrerequist);
    return dispatch(indusindMinKycUserInfoSuccess(response));
  } catch (err) {
    dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
    return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
  }
};

const indusindMinKycUpdate = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.postHandler(api, endpoint.POST_INDUSIND_MIN_KYC, payload, authPrerequist, true);
    if (response && response.status) {
      dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, response.message)));
      await new Promise((resolve) => setTimeout(resolve, 3000));
      dispatch(indusindMinKycUserUpdateSuccess(response));
      return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    }
    throw response.message;
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    return dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
  }
};

const indusindMinKycUserDetails = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.getHandler(api, endpoint.GET_NARADA_USER_DETAILS, payload, authPrerequist, true);
    if (response && response.status) {
      dispatch(indusindMinKycUserDetailsSuccess(response));
      return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    }
    throw response.message;
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    return dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
  }
};

const dedupeVerify = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(clearDefaultError());
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.postHandler(api, endpoint.POST_NARADA_DEDUPE_VERIFY, payload, authPrerequist);
    if (response) {
      dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, response.message)));
      await new Promise((resolve) => setTimeout(resolve, 1000));
      dispatch(dedupeVerifySuccess(response));
      return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    }
    throw response.message;
  } catch (err) {
    dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
    return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
  }
};


export {
  indusindMinKycCities,
  indusindMinKycUserInfo,
  indusindMinKycUpdate,
  indusindMinKycUserDetails,
  dedupeVerify,
};



// WEBPACK FOOTER //
// client/containers/IndusindMinKyc/actions.js